interface UserLike {
  firstName: string | null
  lastName: string | null
  email: string
  imageUrl: string | null
}

interface OrganizationLike {
  id: string
  name: string
  slug: string | null
  imageUrl: string | null
}

interface MembershipLike {
  organizationId: string
  organizationName: string
  organizationSlug: string | null
  organizationImageUrl: string | null
}

export interface UserData {
  name: string
  email: string
  imageUrl: string | null
}

export interface OrganizationData {
  id: string
  name: string
  slug: string | null
  imageUrl: string | null
}

export const transformUserData = (user: UserLike | null): UserData => ({
  name: user ? `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim() || user.email : '',
  email: user?.email ?? '',
  imageUrl: user?.imageUrl ?? null,
})

export const transformOrganizationData = (
  organization: OrganizationLike | null
): OrganizationData | null =>
  organization
    ? {
        id: organization.id,
        name: organization.name,
        slug: organization.slug,
        imageUrl: organization.imageUrl,
      }
    : null

export const transformMembershipsToOrganizations = (
  membershipList: MembershipLike[]
): OrganizationData[] =>
  membershipList.map((membership) => ({
    id: membership.organizationId,
    name: membership.organizationName,
    slug: membership.organizationSlug,
    imageUrl: membership.organizationImageUrl,
  }))
